module.exports = __webpack_public_path__ + "img/IMG_1539_L_Black.e6c5b1ed.jpg";